import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// React components
import MKBox from "components/MKBox";
import MKBadge from "components/MKBadge";
import MKTypography from "components/MKTypography";

// Data
import ImageCarousel from "pages/ImageGallery/ImageCarousel";

function Pages() {
  return (
    <MKBox component="section" py={6}>
      {/* <Container> */}
        <Grid
          container
          item
          xs={12}
          lg={6}
          flexDirection="column"
          alignItems="center"
          sx={{ textAlign: "center", my: 6, mx: "auto", px: 0.75 }}
        >
          <MKBadge
            variant="contained"
            color="success"
            badgeContent="Experience Chess"
            container
            sx={{ mb: 2 }}
          />
          <MKTypography variant="h2" fontWeight="bold">
            Glimpse of IM CHESS
          </MKTypography>
          <MKTypography variant="body1" color="text">
            A Glimpse into the World of IM Chess: Where Dreams Meet Reality.
          </MKTypography>
        </Grid>
      {/* </Container> */}
      {/* <Container> */}
        <Grid container spacing={3} justifyContent={'center'} alignItems={'center'}>
          <ImageCarousel />
          {/* <TitlebarImageGallery /> */}
        </Grid>
      {/* </Container> */}
    </MKBox>
  );
}

export default Pages;
